import script from "./ApplicationMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationMessage.vue?vue&type=style&index=0&id=0c0d89bb&lang=scss&scoped=true"

import exportComponent from "/Users/niitsumahiroyasu/Project/typerunner_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0d89bb"]])

export default __exports__